import { IoMdCloseCircle, } from 'react-icons/io'
import { IoNotificationsSharp, IoCheckbox} from 'react-icons/io5'
import { RiErrorWarningFill} from 'react-icons/ri'
type TypeError = | 'error' | 'problem' | 'success' | 'alert'
interface Props{
  type: TypeError,
  message: string,
}

const Error = ({ message, type}: Props) => {
  return (
    <div className={`c-errors c-errors--${type}`}>
      <span className="c-errors__icon">
        {
          type === 'error' && <IoMdCloseCircle/>
        }
        {
          type === 'problem' && <IoNotificationsSharp/>
        }
        {
          type === 'success' && <IoCheckbox/>
        }
        {
          type === 'alert' && <RiErrorWarningFill/>
        }
      </span>
      <div className="c-errors__box-text">
        <span className="c-errors__title">
          {
            type === 'error' && <>Oops, an error occurred</>
          }
          {
            type === 'problem' && <>Oops, a problem occurred</>
          }
          {
            type === 'success' && <>The action was carried out satisfactorily</>
          }
          {
            type === 'alert' && <>Important Message</>
          }
        </span>
        <span className="c-errors__description">
          {message}
        </span>
      </div>
    </div>
  )
}

export default Error